<template>
  <div>
    <div v-if="hasDataFailMessage()">
      <h1 class="data-fail-message">{{ getDataFailMessage() }}</h1>
      <p v-if="hasDataFailMessage2()" class="data-fail-message-sub">{{ getDataFailMessage2() }}</p>
    </div>
    <b-row v-show="!hasDataFailMessage()">
      <b-col>
        <b-row class="py-3">
          <b-col>
            <h1>Provisionsübersicht</h1>
          </b-col>
        </b-row>
        <b-row class="py-3">
          <b-col>
            <provisionstabelle ref="provisionstabelle"/>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Provisionstabelle from '../common/Provisionstabelle'

export default {
  name: 'PageProvisionsverwaltung',
  components: {Provisionstabelle},
  metaInfo() {
    return {
      title: 'Provisionsverwaltung'
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$refs.provisionstabelle.changedItems.length > 0) {
      if (confirm('Sie haben ungespeicherte Änderungen. Möchten Sie diese Seite verlassen?') === true) {
        next()
      }
      return
    }
    next()
  },
  methods: {
    hasDataFailMessage() {
      return process.env.VUE_APP_DATA_FAIL_MESSAGE_ON_PROVISIONSVERWALTUNG && process.env.VUE_APP_DATA_FAIL_MESSAGE_ON_PROVISIONSVERWALTUNG !== ''
    },
    getDataFailMessage() {
      return process.env.VUE_APP_DATA_FAIL_MESSAGE_ON_PROVISIONSVERWALTUNG
    },
    hasDataFailMessage2() {
      return process.env.VUE_APP_DATA_FAIL_MESSAGE_ON_PROVISIONSVERWALTUNG_2 && process.env.VUE_APP_DATA_FAIL_MESSAGE_ON_PROVISIONSVERWALTUNG_2 !== ''
    },
    getDataFailMessage2() {
      return process.env.VUE_APP_DATA_FAIL_MESSAGE_ON_PROVISIONSVERWALTUNG_2
    },
  },
}
</script>

<style scoped>
.data-fail-message {
  margin-top: 15px;
  text-align: center;
  font-size: 20px;
}
.data-fail-message-sub {
  text-align: center;
  font-size: 16px;
}
</style>
